import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MemberListHeader from 'components/medlemmer/MemberListHeader';
import MembersView from 'components/medlemmer/MembersView';
import { ORDERING_CHOICES, sort } from 'ducks/memberlist';

const mapDispatchToProps = (dispatch) => ({
    sort: (ordering) => dispatch(sort(ordering)),
});

@connect(null, mapDispatchToProps)
class MemberWrapper extends Component {
    static propTypes = {
        selectedOrdering: PropTypes.string.isRequired,
        sort: PropTypes.func.isRequired,
    };

    componentDidMount = () => {
        const { selectedOrdering } = this.props;

        let ordering = ORDERING_CHOICES.default;

        // If ordering was set in the URL and it is a valid ordering key
        if (ORDERING_CHOICES.choices.map((k) => k.value).includes(selectedOrdering)) {
            ordering = selectedOrdering;
        }

        // Set all filters in single action
        this.props.sort(ordering);
    };

    render() {
        return (
            <div>
                <MemberListHeader />
                <MembersView />
            </div>
        );
    }
}

export default MemberWrapper;



// WEBPACK FOOTER //
// ./src/components/medlemmer/MemberWrapper.js